import { QueryKey, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/queries/api-client'

const keys = {
  authUrl: (): QueryKey => ['quickbooksAuthUrl'],
}

export function useQuickbooksAuthUrl() {
  return useQuery({
    queryKey: keys.authUrl(),
    queryFn: async () => {
      const res = await apiClient.get('quickbooks/authUrl')
      return res.data.authUrl ?? null
    },
  })
}

export function useQuickbooksAuth() {
  return useMutation({
    mutationFn: (url: string) => apiClient.post('quickbooks/auth', { url }),
  })
}

export function useQuickbooksDisconnect() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => apiClient.post('quickbooks/disconnect'),
    onSuccess: (res) => {
      queryClient.setQueryData(keys.authUrl(), res.data.authUrl)
    },
  })
}
